
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/myaccount/logindetails",
      function () {
        return require("private-next-pages/myaccount/logindetails.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/myaccount/logindetails"])
      });
    }
  